import React, { useState, useEffect, useCallback } from 'react'
import './pageStyles/destination.min.css'
import Header from '../components/header/header'
import PageHeading from '../components/pageHeading/index'
import HeroDescription from '../components/heroDescription/index'
import PlanetImage from '../components/planetImage/index'
import Tabs from '../components/tabs/index'
import PlanetDescription from '../components/planetDescription/index'

const Destination = ({
  destData
}) => {
  // This is to set the background coz i've been having some trouble setting the background of the various pages using CSS
  const desktopBG = "url('/assets/destination/background-destination-desktop.jpg')"
  const mobileBG = "url('/assets/destination/background-destination-mobile.jpg')"
  
  const memoizedScreenCheck = useCallback(() => {
    if (window.innerWidth < 1000) {
      document.body.style.backgroundImage = mobileBG
    } else {
      document.body.style.backgroundImage = desktopBG
    }
  }, [window.innerWidth])

  useEffect(() => {
    memoizedScreenCheck()
  }, [memoizedScreenCheck])

  // Setting States
  const [currentDest, setCurrentDest] = useState({
    data: destData[0],
    active: 1
  })
  const handleCurrentDest = (number) => {
    setCurrentDest({
      data: destData[number - 1],
      active: number
    })
  }
  
  
  return (
  <div className="container">
    <Header activeLink='2'/>
    <div className="MainContainer padding-16" style={{ minHeight: 'fit-content' }}>
      <PageHeading number="01" text="PICK YOUR DESTINATION"/>
    </div>
    <div className="MainContainer">
      <div className="MainChild">
        <PlanetImage
          image={currentDest.data.images.png} name={currentDest.data.name}
        />
      </div>
      <div className="padding-large">
        <div className="padding-48">
          <Tabs 
            links={['MOON', 'MARS', 'EUROPA', 'TITAN']} width="100%" height="50px"
            active={currentDest.active}
            onClickHandler={handleCurrentDest}
          />
        </div>
        <PlanetDescription planetData={currentDest.data}/>
        <PlanetStatistics distance={currentDest.data.distance} travel={currentDest.data.travel}/>
      </div>
    </div>
  </div>
)}


const PlanetStatistics = ({
  distance, travel
}) => (
  <div className="row-padding">
    <hr style={{ width: '100%', height: '1px', border: 'none', borderTop: '1px solid rgba(255, 255, 255, 0.1)' }}/>
    <div className="half">
      <PlanetStat heading="AVG. DISTANCE" statistic={distance} />
    </div>
    <div className="half">
      <PlanetStat heading="EST. TRAVEL TIME" statistic={travel} />
    </div>
  </div>
)

const PlanetStat = ({ heading, statistic }) => (
  <>
    <p className="opacity-min medium">{heading}</p>
    <p className="large" style={{ textTransform: 'uppercase' }}>{statistic}</p>
  </>
)

export default Destination